import React from 'react';
import { useTranslation } from 'react-i18next';
import {useDispatch} from "react-redux";
import { closeDialog } from '../../../../store/actionCreators/dialog'

const ComingSoon =({val}) => {
  const { t } = useTranslation();
    const dispatch = useDispatch();
    const close = () => {
        dispatch(closeDialog());
    }
    return (
        <div className={`comingSoon`}>
            <div className={`icon`}></div>
            <div className={`missionText`}>{val}{t('areComingSoon')}...</div>
            <div className={`dialogConfirmBox`} onClick={close}>
                <button className="primary">{t('button.close')}</button>
            </div>
        </div>
    );
};

export default ComingSoon;
